import formatNumber from "./format-number";

export default cents => `$${formatNumber((cents / 100), 0)}`;
